import { Share2 } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { ShareDialog } from '@/components/ShareDialog';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { useToast } from '@/hooks/useToast';
import type { MusicTrack } from '@/lib/musicTypes';

interface ShareButtonProps {
  track: MusicTrack;
  size?: 'default' | 'sm' | 'lg' | 'icon';
  variant?: 'default' | 'ghost' | 'outline' | 'secondary';
  className?: string;
}

export function ShareButton({ track, size = 'icon', variant = 'ghost', className }: ShareButtonProps) {
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const { user } = useCurrentUser();
  const { toast } = useToast();

  const handleShare = () => {
    if (!user) {
      toast({
        title: 'Login Required',
        description: 'You must be logged in to share tracks',
        variant: 'destructive',
      });
      return;
    }

    setShareDialogOpen(true);
  };

  return (
    <>
      <Button
        size={size}
        variant={variant}
        className={className}
        onClick={handleShare}
      >
        <Share2 className="h-4 w-4" />
      </Button>

      <ShareDialog
        track={track}
        open={shareDialogOpen}
        onOpenChange={setShareDialogOpen}
      />
    </>
  );
}
